import React, { useState } from 'react';
import "./Configure.css";
import RemoteConfigView from "../RemoteConfig/RemoteConfigView";
import AddRemoteConfigModal from "../RemoteConfig/AddRemoteConfigModal";
import AuditLogModal from "../RemoteConfig/AuditLogModal";

const Configure = () => {
  const [showAddModal, setShowAddModal] = useState(false);
  const [showAuditModal, setShowAuditModal] = useState(false);
  // Optional: trigger refresh on view
  const [refreshKey, setRefreshKey] = useState(0);
  return (
    <div className="config-container" style={{ padding: '25px', backgroundColor: '#F8FAFC',  }}>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h2 className="config-title mb-1" style={{ color: '#1E293B', fontWeight: '700' }}>Configuration</h2>
          <p className="text-muted mb-0">Manage your remote application configurations</p>
        </div>
        <div style={{ display: 'flex', gap: '12px' }}>
          <button
            type="button"
            onClick={() => setShowAuditModal(true)}
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "8px",
              padding: "10px 20px",
              backgroundColor: "#FFFFFF",
              color: "#475569",
              border: "1px solid #CBD5E1",
              borderRadius: "8px",
              fontSize: "14px",
              fontWeight: "600",
              cursor: "pointer",
              boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
              transition: "all 0.2s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#F8FAFC";
              e.currentTarget.style.borderColor = "#94A3B8";
              e.currentTarget.style.color = "#1E293B";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#FFFFFF";
              e.currentTarget.style.borderColor = "#CBD5E1";
              e.currentTarget.style.color = "#475569";
            }}
          >
            <i
              className="fa fa-history"
              style={{
                fontSize: "13px",
              }}
            />
            <span>Audit Log</span>
          </button>
          
          <button
            type="button"
            onClick={() => setShowAddModal(true)}
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "8px",
              padding: "10px 20px",
              backgroundColor: "#2563EB",
              color: "#FFFFFF",
              border: "1px solid #2563EB",
              borderRadius: "8px",
              fontSize: "14px",
              fontWeight: "600",
              cursor: "pointer",
              boxShadow: "0 3px 8px rgba(37, 99, 235, 0.20)",
              transition: "all 0.2s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#1D4ED8";
              e.currentTarget.style.borderColor = "#1D4ED8";
              e.currentTarget.style.boxShadow =
                "0 5px 12px rgba(37, 99, 235, 0.28)";
              e.currentTarget.style.transform = "translateY(-1px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#2563EB";
              e.currentTarget.style.borderColor = "#2563EB";
              e.currentTarget.style.boxShadow =
                "0 3px 8px rgba(37, 99, 235, 0.20)";
              e.currentTarget.style.transform = "translateY(0)";
            }}
          >
            <i
              className="fa fa-plus"
              style={{
                fontSize: "13px",
              }}
            />
            <span>Add Config</span>
          </button>
        </div>
      </div>

      <RemoteConfigView key={refreshKey} />

      <AddRemoteConfigModal 
        show={showAddModal} 
        onHide={() => setShowAddModal(false)} 
        onSuccess={() => setRefreshKey(prev => prev + 1)} 
      />
      
      <AuditLogModal 
        show={showAuditModal} 
        onHide={() => setShowAuditModal(false)} 
      />
    </div>
  );
};

export default Configure;




